var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgId = function SvgId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9d1b",
    d: "M65.855 12v49.713a4 4 0 0 1-4 4H27.232a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h34.623a4 4 0 0 1 4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#74cafc",
    d: "M59.766 18.077V67.8a4 4 0 0 1-4 4H18.098a4 4 0 0 1-4-4V18.077a4 4 0 0 1 4-4h37.668a4 4 0 0 1 4 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.4,
    height: 21.262,
    x: 23.23,
    y: 23.188,
    fill: "#3da1db",
    rx: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#74cafc",
    d: "M43.197 52.177a1.347 1.347 0 0 0 1.35-1.34v-11.64a2.16 2.16 0 0 0-.639-1.529 2.17 2.17 0 0 0-1.535-.63h-4.83a5.43 5.43 0 0 0 4.817-5.696 5.43 5.43 0 0 0-5.428-5.119 5.43 5.43 0 0 0-5.428 5.119 5.43 5.43 0 0 0 4.817 5.695h-4.825a2.17 2.17 0 0 0-1.536.631 2.16 2.16 0 0 0-.638 1.53v11.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3da1db",
    d: "M49.096 53.563a2 2 0 0 1-.416-.044H25.72q-.203.044-.416.044c-.952 0-1.704-.67-1.704-1.488s.777-1.542 1.733-1.542h23.734c.952 0 1.733.69 1.733 1.542s-.765 1.488-1.704 1.488m0 6.075a2 2 0 0 1-.416-.045H25.72q-.203.045-.416.045c-.952 0-1.704-.67-1.704-1.488s.777-1.542 1.733-1.542h23.734c.952 0 1.733.69 1.733 1.542s-.765 1.488-1.704 1.488m0 6.075a2 2 0 0 1-.416-.045H25.72q-.203.045-.416.045c-.952 0-1.704-.67-1.704-1.49s.777-1.54 1.733-1.54h23.734c.952 0 1.733.7 1.733 1.54s-.765 1.49-1.704 1.49"
  })));
};
export default SvgId;